document.addEventListener("DOMContentLoaded", function () {

  const wrapper = document.querySelector(".trust-bar__wrapper");

  if (!wrapper) return;

  if (window.innerWidth < 990) {

    wrapper.style.scrollSnapType = "x mandatory";

    wrapper.querySelectorAll(".trust-item").forEach(item => {

      item.style.scrollSnapAlign = "center";

    });

  }

});